<script>
import locator from '@/service-locator'
import TrackingEvents from '@/plugins/tracking/event'

export default {
  name: 'ZendeskChatbotButton',
  computed: {
    isEnableSupportWidget() {
      return (
        this.$abtProvider.isFeatureEnabled('merchant_enabled_support_widget') ||
        false
      )
    },
    shouldDisplayChatbotButton() {
      if (!this.isEnableSupportWidget) {
        return true
      }

      return this.$route.path.includes('/login')
    },
  },
  methods: {
    onShowZEChatBot() {
      this.$track.event(TrackingEvents.global_chat_with_us)
      locator.chatbot.openChatbot()
    },
  },
}
</script>

<template>
  <div
    v-if="shouldDisplayChatbotButton"
    class="zendesk-custom-launcher"
    @click="onShowZEChatBot"
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.07532 17.3535L1.66602 18.3333L2.64586 13.924C2.02055 12.7546 1.66602 11.4187 1.66602 9.99996C1.66602 5.39758 5.39697 1.66663 9.99935 1.66663C14.6017 1.66663 18.3327 5.39758 18.3327 9.99996C18.3327 14.6023 14.6017 18.3333 9.99935 18.3333C8.5806 18.3333 7.24468 17.9788 6.07532 17.3535Z"
        fill="#212442"
      />
      <path
        d="M12.3477 7.74951C13.5772 7.74951 14.574 8.7466 14.5742 9.97607C14.5742 11.2058 13.5774 12.2026 12.3477 12.2026C11.1181 12.2025 10.1211 11.2057 10.1211 9.97607C10.1213 8.74666 11.1182 7.74962 12.3477 7.74951ZM7.32227 7.75928C7.90609 7.74674 8.47161 7.96593 8.89355 8.36963C9.37895 8.83324 10.1786 10.2112 8.96094 11.4829L8.89746 11.5483C8.76875 11.6819 8.62388 11.7989 8.46582 11.896L5.25 9.22998C5.35489 8.95854 5.51247 8.71054 5.71387 8.50049L5.7793 8.43701C6.18347 8.01562 6.73852 7.77187 7.32227 7.75928Z"
        fill="#E2E2FF"
      />
    </svg>
    <span class="tamara-english-medium-3">Chat with us - تواصل معنا</span>
  </div>
</template>

<style lang="scss">
// Override the default launcher style
#launcher {
  display: none;
}

/* Add custom CSS to style the launcher */
.zendesk-custom-launcher {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 400;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  min-width: 95px;
  height: 48px;
  padding: 12px 16px;
  overflow: hidden;
  color: rgb(0, 0, 0);
  cursor: pointer;
  background-color: #e2e2ff;
  border: none;
  border-radius: 128px;
  box-shadow: none;
  transition: 200ms opacity ease;
  animation: button-fade-in 200ms ease 0s;
  direction: ltr;

  &:hover {
    background-color: #ccccf7;
  }
}

.zendesk-custom-launcher span {
  -webkit-font-smoothing: antialiased;
}

.zendesk-custom-launcher svg {
  top: -1px;
  width: 20px;
  height: 20px;
  padding: 0;
}

[dir='rtl'] {
  .zendesk-custom-launcher {
    right: unset;
    left: 24px;
  }

  iframe[name='نافذة المراسلة'] {
    right: unset !important;
    left: 24px !important;
  }
}
</style>
